/**
 * VehicleTabsNav — sub-navigator la începutul paginilor Autoturisme și Remorci,
 * pentru switch rapid între cele 2 secțiuni (Remorci a fost mutat sub Autoturisme
 * pentru a curăța sidebar-ul).
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { Car, Truck, History } from "lucide-react";

const TABS = [
  { to: "/autoturisme", label: "Autoturisme", icon: Car },
  { to: "/remorci", label: "Remorci", icon: Truck },
  { to: "/istoric-intretinere", label: "Istoric întreținere", icon: History },
];

export default function VehicleTabsNav() {
  return (
    <nav className="flex items-center gap-1 mb-4 border-b border-zinc-200" data-testid="vehicle-tabs-nav">
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                isActive
                  ? "border-amber-500 text-amber-700 bg-amber-50/50"
                  : "border-transparent text-zinc-600 hover:text-zinc-900 hover:bg-zinc-50"
              }`
            }
            data-testid={`vehicle-tab-${t.to.replace("/", "")}`}
          >
            <Icon size={16}/> {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
